// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1161":"726177159b9ef1cf","2888":"e78eadd305cbbf2b","5416":"726177159b9ef1cf","9970":"726177159b9ef1cf"}[chunkId] + ".css";
};